const TOPICS = {
  SHOW_MODAL_DIALOG: 'SHOW_MODAL_DIALOG',
  CHANGE_LOADING_STATUS: 'CHANGE_LOADING_STATUS',
  CHANGE_ERROR_STATUS: 'CHANGE_ERROR_STATUS',
};

export default TOPICS;
